import React, { ChangeEventHandler } from "react";
import { Titillium_Web } from "next/font/google";
const tw = Titillium_Web({ weight: ["300", "400"], subsets: ["latin"] });

interface SelectProps {
    placeholder?: string;
    label?: string;
    onChange?: ChangeEventHandler<HTMLSelectElement>;
    type?: string;
    value?: string;
    disabled?: boolean;
    fill?: boolean;
    id?: string;
    children: any[];
}

export function Select(props: SelectProps) {

    return <>
        <div className={`input-container ${props.fill && "fill"}`}>
            <label>{props.label}</label>
            <select id={props.id} onChange={props.onChange} >
                {props.children}
            </select>
        </div>
        <style jsx>
            {`
            .disabled{
                background:#F2F2F2;
                color:#868E96;
            }
            .input-container{
                display:flex;
                flex-direction: column;
                gap:4px;
                font-family: ${tw.style.fontFamily} , sans-serif;
            }
            .fill{
                width:100%;
                flex-grow:1;
            }
            select {
                -webkit-box-sizing: border-box;
                box-sizing: border-box;
                display: -webkit-box;
                display: flex;
                -webkit-box-orient: horizontal;
                flex-direction: row;
                -webkit-box-align: start;
                align-items: flex-start;
                padding: 10px;
                gap: 10px;
                width: 100%;
                font-size: var(--font-size-3);
                height: 48px;
                background: #FFFFFF;
                border: 1px solid var(--border-color);
                border-radius: 4px;
                -webkit-flex: none;
                flex: none;
                order: 1;
                -webkit-align-self: stretch;
                align-self: stretch;
                -webkit-flex-grow: 0;
                flex-grow: 0;
                -webkit-appearance: none; /* Safari-specific prefix */
                appearance: none; /* Standard property */
                place-items: center;
              }
              
            label{
                font-size:var( --font-size-2);
                color: ${props.disabled && "gray"};
            }
            `}
        </style>
    </>;
}
